// import * as actions from 'actions';
import { APP_TABS, GROUP_ROLES, FINISHED, CONV_TYPE, SUCCESS } from 'constants';
import { lang } from 'lang';
import { cache } from 'utils';

let dispatch; // eslint-disable-line
let getState;
export const setDispatcher = (newDispatch, newGetState) => {
  dispatch = newDispatch;
  getState = newGetState;
};
export const getRouteIndex = selected_tab => {
  const state = getState();
  const routeIndex = {
    [APP_TABS.GROUPS]: (state.ui.selected_group && 1) || 0,
    [APP_TABS.SETTINGS]: (state.ui.selected_settings_item && 1) || 0,
    [APP_TABS.PM]: (state.ui.selected_pm && 1) || 0
  };
  return routeIndex[selected_tab];
};
export const PMFromGroup = () => getState().ui.selected_group;
export const getSelectedConvId = base_state => {
  const state = base_state || getState();
  return state.ui.selected_app_tab === APP_TABS.PM || state.ui.route_index > 2 ? state.ui.selected_pm : state.ui.selected_group;
};

export const getMessagesBase = ({ type, conv_id }) => {
  const state = getState();
  const messages = objToArray(state, 'conv', conv_id, type);
  return messages.length ? messages : !isPageMessages(conv_id) ? [getSelectedConv({ id: conv_id }).last_msg] : [];
};

export const getPageMessages = conv_id => getMessagesBase({ conv_id, type: 'page_messages' });
export const getRecentMessages = conv_id => getMessagesBase({ conv_id, type: 'recent_messages' });

export const getMessages = conv_id => {
  conv_id = conv_id || getSelectedConvId();
  return isPageMessages(conv_id) ? getPageMessages(conv_id) : getRecentMessages(conv_id);
};

export const isPageMessages = (conv_id, state) => {
  if (state) {
    return !!nullInPath(state, conv_id, 'page_messages');
  }
  return !!nullInPath(getState(), 'conv', conv_id, 'page_messages');
};

export const getSelectedGroupMembers = () => {
  const state = getState();
  const group_id = state.ui.selected_group;
  const action = (a, b) => {
    return a.role > b.role;
  };
  const filter = f => f.role !== GROUP_ROLES.LEFT && f.role !== GROUP_ROLES.REMOVED && f.role !== GROUP_ROLES.BLOCKED;
  return objToArray(state, 'conv', group_id, 'members', action, filter);
};

export const isMyMessage = message => message.user.id === getState().user.id;
export const isDeletedMsg = message => {
  const id = getState().user.id;
  return message.deleted && message.deleted[id];
};

export const getSelectedGroup = id => getSelectedConv({ type: APP_TABS.GROUPS, id });
export const getSelectedPM = id => getSelectedConv({ type: APP_TABS.PM, id });

export const getSelectedConv = ({ type, id } = {}) => {
  const state = getState();

  const conv_id = id || (type ? (type === APP_TABS.PM ? state.ui.selected_pm : state.ui.selected_group) : getSelectedConvId());
  const list = state.conv.list;
  const cached_index = cache.get(`conv_index_${conv_id}`);
  if ((cached_index || cached_index === 0) && state.conv.list[cached_index].id === conv_id) {
    return state.conv.list[cached_index];
  }
  return list.find((obj, index) => {
    if (obj.id === conv_id) {
      cache.set(`conv_index_${conv_id}`, index);
      return obj;
    }
    return null;
  });
};

export const getUnreadGroupCount = () => getUnreadConv('GROUP');

export const getUnreadPMCount = () => getUnreadConv(APP_TABS.PM);

const getUnreadConv = type => {
  const cached_count = cache.get(`unread_count_${type}`);
  const count_ref = getState().conv.list;
  if (cached_count === count_ref) {
    return cache.get(`reduced_count_${type}`);
  } else {
    const count = getState().conv.list.reduce((acc, current) => (current.type === type ? (current.unread_msg ? 1 : 0) + acc : acc), 0);
    cache.set(`unread_count_${type}`, count_ref);
    cache.set(`reduced_count_${type}`, count);
    return count;
  }
};

export const nullInPath = (base, ...args) => {
  let result = base;
  for (let i = 0; i < args.length; i++) {
    result = result[args[i]];
    if (!result) {
      break;
    }
  }
  return result;
};

export const objToArray = (state, branch, id, type, action, filter, cache_prefix = '') => {
  const cache_value = cache.get(`${cache_prefix}objToArray_obj_${branch}_${id}_${type}`);
  const obj_ref = nullInPath(state, branch, id, type);
  if (cache_value === obj_ref) {
    // (type === 'recent_messages' || type === 'page_messages') && console.log('from cache ', type);
    return cache.get(`${cache_prefix}objToArray_array_${branch}_${id}_${type}`) || cache.empty_array;
  } else {
    if (obj_ref) {
      let array = Object.values(state[branch][id][type]);
      if (typeof action === 'function') {
        array = array.sort(action);
      } else {
        array = action ? array : array.reverse();
      }
      if (filter) {
        array = array.filter(filter);
      }
      // (type === 'recent_messages' || type === 'page_messages') && console.log('from DB ', type);
      cache.set(`${cache_prefix}objToArray_array_${branch}_${id}_${type}`, array);
      cache.set(`${cache_prefix}objToArray_obj_${branch}_${id}_${type}`, obj_ref);
      return array;
    }
    return cache.empty_array;
  }
};

// we use this to populate files in uploadlist in materials
export const getFilesForUploadList = ({ g_id, u_id }) => {
  const state = getState();
  return objToArray(state, 'uploader', g_id, u_id, null, file => file.status !== FINISHED);
};
export const getFileFromUploadsGroup = (uploads, u_id, file_id) => {
  // incase the file_id is not supplied, take the last file_id from uploader
  const uploads_arr = uploads && uploads[u_id] && Object.keys(uploads[u_id]);

  file_id = file_id || (uploads_arr && uploads_arr[uploads_arr.length - 1]);
  if (!uploads || !uploads[u_id] || !uploads[u_id][file_id] || uploads[u_id][file_id].status === FINISHED) {
    return null;
  }
  return uploads[u_id][file_id];
};
// we use this to send files to the server
export const getUploadedFiles = ({ g_id, u_id }) =>
  objToArray(getState(), 'uploader', g_id, u_id, null, file => file.status === SUCCESS, SUCCESS).map(upload => ({
    file_id: upload.file_id,
    name: upload.name
  }));

export const getSessions = () => getState().auth.list;

export const getTypingIndicatorText = selected => {
  const user_id = getState().user.id;
  let typing_indicators = selected.typing_indicator && { ...selected.typing_indicator };
  if (!typing_indicators) {
    return null;
  }
  delete typing_indicators[user_id];
  typing_indicators = Object.values(typing_indicators);
  const typing_length = typing_indicators.length;
  return (
    (typing_length === 1 && `${typing_indicators[0].name.split(' ')[0]} ${lang.SINGLE_TYPING} ...`) ||
    (typing_length === 2 && `${typing_indicators[0].name.split(' ')[0]} ${lang.AND} ${typing_indicators[1].name.split(' ')[0]} ${lang.PLURAL_TYPING} ...`) ||
    (typing_length > 2 && `${typing_indicators[0].name.split(' ')[0]} ${lang.AND} ${typing_length - 1} ${lang.MORE} ${lang.PLURAL_TYPING} ...`) ||
    null
  );
};

export const getWatching = selected => {
  return (selected.watching && `(${Object.keys(selected.watching).length}/${selected.total_admin + selected.total_partic} ${lang.SINGLE_WATCHING} ${lang.NOW})`) || '';
};

export const getGroupList = () => getChatList(CONV_TYPE.GROUP);

export const getPMList = () => getChatList(CONV_TYPE.PM);

const getChatList = type => {
  const cached_list = cache.get(`chat_list_${type}`);
  const list_ref = getState().conv.list;
  if (list_ref === cached_list) {
    return cache.get(`filter_${type}`);
  } else {
    const result = list_ref.filter(obj => obj.type === type);
    cache.set(`filter_${type}`, result);
    cache.set(`chat_list_${type}`, list_ref);
    return result;
  }
};

export const getContact = () => {
  const state = getState();
  const msg = nullInPath(state, 'ui', 'selected_msg');
  const contact = msg && msg.data;
  return contact;
};

export const getUser = () => getState().user;



// WEBPACK FOOTER //
// ./src/reducers/selectors.js